var map = {
	"./de/btn-detail.png": "CKRK",
	"./en/btn-detail.png": "bUHx",
	"./es/btn-detail.png": "Ba17",
	"./fr/btn-detail.png": "+ned",
	"./ja/btn-detail.png": "Ymmn",
	"./ko/btn-detail.png": "tf/M",
	"./pt/btn-detail.png": "6XDU",
	"./ru/btn-detail.png": "+1do",
	"./th/btn-detail.png": "hGG1",
	"./zh-Hant/btn-detail.png": "Xch+"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vegF";